export interface InformationBanner {
  displayInformationBanner: boolean;
  informationBannerMessage: string;
  informationBannerType: InformationBannerType;
}

export enum InformationBannerType {
  Information = 1,
  Positive = 2,
  Warning = 3,
  Critical = 4,
}
